import {
  GET_API_IMPORT_SETTINGS_REQUEST,
  GET_API_IMPORT_SETTINGS_SUCCESS,
  GET_API_IMPORT_SETTINGS_ERROR,
  ROTATE_INTEGRATION_KEY_SUCCESS,
  UPDATE_API_IMPORT_SETTINGS_REQUEST,
  UPDATE_API_IMPORT_SETTINGS_SUCCESS,
  UPDATE_API_IMPORT_SETTINGS_ERROR,
  TRIGGER_API_IMPORT_REQUEST,
  TRIGGER_API_IMPORT_SUCCESS,
  TRIGGER_API_IMPORT_ERROR,
  TEST_API_CONNECTION_REQUEST,
  TEST_API_CONNECTION_SUCCESS,
  TEST_API_CONNECTION_ERROR,
} from "../types";

const initialState = {
  settings: {
    enabled: false,
    api_base_url: "",
    api_url_pattern: "",
    auth_type: "NONE",
    auth_credentials: "",
    api_key_header_name: "X_API_KEY",
    basic_auth_username: "",
    basic_auth_password: "",
    basic_auth_configured: false,
    timeout_ms: 30000,
    max_retries: 3,
    project_codes: "",
    cron_enabled: false,
    cron_time: "",
    cron_days: [],
  },
  lastRunResult: null,
  loading: false,
  error: null,
  // True once a GET actually succeeded. Guards destructive saves: a form
  // seeded from the reducer DEFAULTS (auth_type NONE, enabled false) that is
  // PUT back would wipe stored credentials and disable the import.
  loaded: false,
  importing: false,
  testingConnection: false,
  connectionTestResult: null,
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, { type, payload }) {
  switch (type) {
    case GET_API_IMPORT_SETTINGS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_API_IMPORT_SETTINGS_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        settings: {
          ...initialState.settings,
          ...(payload || {}),
        },
        error: null,
      };
    case GET_API_IMPORT_SETTINGS_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    // Inbound key rotation (API exchanges tab): apply the new prefix locally
    // instead of refetching — a refetch would replace the whole settings
    // object and reseed both settings tabs' forms, discarding drafts.
    case ROTATE_INTEGRATION_KEY_SUCCESS:
      return {
        ...state,
        settings: {
          ...state.settings,
          inbound_api_key_prefix: payload.api_key_prefix,
          inbound_api_key_configured: true,
        },
      };

    case UPDATE_API_IMPORT_SETTINGS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case UPDATE_API_IMPORT_SETTINGS_SUCCESS:
      return {
        ...state,
        loading: false,
        settings: {
          ...state.settings,
          ...(payload || {}),
        },
        error: null,
      };
    case UPDATE_API_IMPORT_SETTINGS_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    case TRIGGER_API_IMPORT_REQUEST:
      return {
        ...state,
        importing: true,
        error: null,
      };
    case TRIGGER_API_IMPORT_SUCCESS:
      return {
        ...state,
        importing: false,
        lastRunResult: payload,
        error: null,
      };
    case TRIGGER_API_IMPORT_ERROR:
      return {
        ...state,
        importing: false,
        error: payload,
      };

    case TEST_API_CONNECTION_REQUEST:
      return {
        ...state,
        testingConnection: true,
        connectionTestResult: null,
        error: null,
      };
    case TEST_API_CONNECTION_SUCCESS:
      return {
        ...state,
        testingConnection: false,
        connectionTestResult: payload,
        error: null,
      };
    case TEST_API_CONNECTION_ERROR:
      return {
        ...state,
        testingConnection: false,
        connectionTestResult: null,
        error: payload,
      };

    default:
      return state;
  }
}
